<!--
  One game, as a tile.

  Lifted verbatim out of MainPage's "Your Games" grid so the home page, the
  full library at /my-games and the signed-in home at /main cannot drift apart
  visually. Three copies of this markup was how they would have.

  Drop it inside a `.row.row-cols-1.row-cols-md-3.g-4` — the tile owns the
  column so a caller cannot get the grid wrong.
-->
<template>
  <div class="col">
    <div class="card h-100">
      <div class="card-img-container">
        <img
          :src="game.headerImageUrl || fallbackImage"
          class="card-img-top w-100"
          :alt="`${game.name} board game`"
        >
      </div>
      <div class="card-body">
        <h5 class="card-title">{{ game.name }}</h5>
        <p class="card-text">{{ shortDescription }}</p>
        <div class="d-flex justify-content-between align-items-center">
          <span class="badge bg-secondary">{{ typeLabel }}</span>
          <div class="d-flex gap-1">
            <!-- Boards were only reachable by opening the game first and
                 finding the link inside it. They are the thing you print, so
                 they get a way in from the tile. -->
            <router-link
              :to="{ name: 'BuildBoards', params: { boardGameId: game.id } }"
              class="btn btn-outline-primary btn-sm"
            >
              Boards
            </router-link>
            <router-link
              :to="{ name: 'BoardGameDetail', params: { id: game.id } }"
              class="btn btn-primary btn-sm"
            >
              View
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// The same stand-in the main page has always used for a game with no banner.
const DEFAULT_COVER =
  'https://storage.googleapis.com/rpg-framework-a73be.appspot.com/CastleIntro.jpg'

export default {
  name: 'GameTile',
  props: {
    game: { type: Object, required: true },
    descriptionLength: { type: Number, default: 100 }
  },
  computed: {
    fallbackImage() {
      return DEFAULT_COVER
    },
    shortDescription() {
      const text = this.game.description || ''
      return text.length > this.descriptionLength
        ? `${text.substring(0, this.descriptionLength)}...`
        : text
    },
    typeLabel() {
      // Games created before `type` was required still exist, and .charAt on
      // undefined is a render-breaking TypeError rather than a missing badge.
      const type = this.game.type
      return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'Game'
    }
  }
}
</script>

<style scoped>
.card-img-container {
  height: 200px;
  overflow: hidden;
}
.card-img-container img {
  height: 100%;
  object-fit: cover;
}
</style>
